import { render, staticRenderFns } from "./TfootPercentPockets.vue?vue&type=template&id=d8c420b2"
import script from "./TfootPercentPockets.vue?vue&type=script&lang=js"
export * from "./TfootPercentPockets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports